import cx from "clsx";
import type React from "react";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { isDealBillingContext } from "~/models/DealConstruction";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionList.module.scss";

type Props = {
	companyType: "client" | "vendor" | "partner";
	constructionContext: DealConstructionContext;
	docType: "billing" | "estimation";
	hasVendorFee: boolean;
	showButtons: boolean;
	showEstimationConfirmedButton?: boolean;
	showSwitchEnable?: boolean;
	target: "owner" | "rentee" | null;
};

export const ConstructionListFooterRow: React.FC<Props> = ({
	constructionContext,
	showSwitchEnable = false,
	showButtons,
	target,
	companyType,
	docType,
	hasVendorFee,
	showEstimationConfirmedButton = false
}: Props) => {
	const { totalAmount, totalAmountWithTax } = constructionContext;
	const isClientEstimation =
		companyType === "client" && docType === "estimation";
	const footerLabel = ((): string => {
		if (docType === "billing") return "施工項目合計";
		if (hasVendorFee && companyType !== "client")
			return "差引（手数料控除後金額）";
		return "合計";
	})();
	return (
		<tr
			className={
				showEstimationConfirmedButton
					? cx(Styles.ListRow, Styles.TwoTierFooter)
					: cx(Styles.ListRow, Styles.Footer)
			}
		>
			<td className={Styles.OrderHandle} />
			{showSwitchEnable ? <td className={Styles.SwitchEnable} /> : null}
			{docType === "estimation" ? (
				<td className={Styles.EstimationType} />
			) : null}
			<td className={Styles.Estimation}>
				<div className={isClientEstimation ? Styles.SumPoint : Styles.Point}>
					{footerLabel}
				</div>
				{isClientEstimation ? (
					<span className={Styles.TaxAnnotate}>
						課税方法の変更に伴う、イタンジ請求書金額とのずれについては
						<a
							className={Styles.TaxChangeLink}
							href="https://itandibb.support.itandi.co.jp/hc/ja/articles/40103215836307"
							rel="noreferrer"
							target="_blank"
						>
							こちら
						</a>
					</span>
				) : null}
			</td>
			<td className={Styles.UnitAmount} />
			<td className={Styles.ChargePer} />
			{target !== null && (
				<td className={Styles.ForAmount}>
					{target === "rentee" && isDealBillingContext(constructionContext) && (
						<div>
							¥{toThousandSeparator(constructionContext.sumRenteeAmount)}
							<div>
								(税込：¥
								{toThousandSeparator(
									constructionContext.sumRenteeAmountWithTax
								)}
								)
							</div>
						</div>
					)}
					{target === "owner" && isDealBillingContext(constructionContext) && (
						<div>
							¥{toThousandSeparator(constructionContext.sumOwnerAmount)}
							<div>
								(税込：¥
								{toThousandSeparator(constructionContext.sumOwnerAmountWithTax)}
								)
							</div>
						</div>
					)}
				</td>
			)}
			<td className={Styles.Amount}>
				<div>
					¥{toThousandSeparator(totalAmount)}
					<div>(税込：¥{toThousandSeparator(totalAmountWithTax)})</div>
				</div>
			</td>
			{showButtons ? <td className={Styles.Buttons} /> : null}
		</tr>
	);
};
